import React, { useEffect, useState } from 'react'
import { Modal } from '@ui/components/Modal'
import QrModalContent from './QrModalContent'
import { useQrScanner } from './useQrScanner'
import { useCustomer, useStaff } from 'hooks/useSession'
import { useIsNavigationReady } from 'hooks/useIsNavigationReady'
// import AnimatedModalPanel from '@ui/animated/AnimatedModalPanel'
// import Glass from '@ui/elements/Glass'

const BackgroundQrScanner = () => {
  const { mode, close, visible, setMode } = useQrScanner()
  const [ready, setReady] = useState(false)
  const isCustomer = !!useCustomer()
  const isStaff = !!useStaff()

  const isNavReady = useIsNavigationReady()

  useEffect(() => {
    // Disable the scanner if we have a user for the current mode
    if (isCustomer && mode === 'customer') {
      setMode('disabled')
      return
    }

    if (isStaff && mode === 'staff') {
      setMode('disabled')
      return
    }
  }, [isCustomer, isStaff, mode])

  useEffect(() => {
    setTimeout(() => {
      setReady(true)
    }, 10_000)
  }, [])

  if (!isNavReady && !ready) {
    return
  }

  return (
    <>
      <Modal
        persistent
        enabled={visible}
        onClose={close}
        hostName="persistent"
        contentClassName="items-center"
      >
        {mode !== 'disabled' && (
          <QrModalContent visible={visible} close={close} />
        )}
      </Modal>
    </>
  )
}

export default BackgroundQrScanner
